import { useState } from "react";
import styles from "./style/Dashboard.module.scss";
import Modal from "../Utilities/Modal";
import Table from "../Utilities/Table";
import Button from "../Utilities/Button";
import Paginate from "../Utilities/Paginate";
import { MdClear, MdEdit, MdMarkEmailRead } from "react-icons/md";
import { FiCheck, FiDownload, FiUpload } from "react-icons/fi";
import EmptyBox from "../Utilities/EmptyBox";
import Alert from "../Utilities/Alert";
import { useDispatch, useSelector } from "react-redux";
import {
  getHistoryStartOne,
  getUserLists,
  postCancelGift,
  updateInvoiceStatus,
  postManualInvoice,
  deleteManualInvoice,
  getManualInvoice,
  resendInvoiceMail,
  selectEnterpriseCompany,
} from "../../store/slice/manager/enterpriseCompany";
import LoadingTable from "../Utilities/LoadingTable";
import moment from "moment";

const ModalHistory = ({
  isOpen,
  setIsOpen,
  refreshPersonalList,
  // findTopUpForUser,
  // getTopUpValue,
}) => {
  const headerData = [
    {
      title: '日期',
      width: 10,
    },
    {
      title: '說明',
      width: 15,
    },
    {
      title: '金額',
      width: 10,
    },
    {
      title: "付款方式",
      width: 12,
    },
    {
      title: '統一編號',
      width: 10,
    },
    {
      title: "付款狀態",
      width: 13,
    },
    {
      title: "發票管理",
      width: 30,
    },
  ];

  const dispatch = useDispatch();
  const { order_history, loading } = useSelector(selectEnterpriseCompany);
  // const [orderHistory, setOrderHistory] = useState([]);
  const [page, setPage] = useState(1);
  const [cancelAlert, setCancelAlert] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [cancelReason, setCancelReason] = useState('');
  const [cancelReasonError, setCancelReasonError] = useState(false);
  const [invoiceAlert, setInvoiceAlert] = useState(false);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [editTaxId, setEditTaxId] = useState("");
  const [resendingIds, setResendingIds] = useState([]);
  const limit = 10;

  const handleResendInvoice = async (data) => {
    const orderId = data.order_id;
    if (!orderId || resendingIds.includes(orderId)) return;
    setResendingIds((prev) => [...prev, orderId]);
    try {
      const res = await dispatch(resendInvoiceMail({ serviceId: 8, orderUuid: orderId })).unwrap();
      window.alert(res?.action === 'issued' ? '已開立並寄出發票' : '已重新寄出發票');
    } catch (e) {
      window.alert('補送失敗：' + (e?.message || '請查看後端 log'));
    } finally {
      setResendingIds((prev) => prev.filter((id) => id !== orderId));
    }
  };

  const pageChangeHandler = (e) => {
    setPage(parseInt(e.selected + 1));
    const postObj = {
      user_id: isOpen?.user_information?.user_id,
      page: e.selected + 1,
      limit: limit,
    };
    dispatch(getHistoryStartOne(postObj));
  };

  const handleCancelOrder = (order) => {
    setSelectedOrder(order);
    setCancelAlert(true);
  };

  const confirmCancelOrder = () => {
    // Validate cancelReason is not empty
    if (!cancelReason || cancelReason.trim() === '') {
      setCancelReasonError(true);
      return;
    }

    // Add cancel order logic here
    dispatch(
      postCancelGift({
        userId: isOpen?.id,
        orderId: Number(selectedOrder?.order_id),
        // cancelReason: cancelReason,
      })
    ).then(() => {
      const postObj = {
        user_id: isOpen?.user_information?.user_id,
        page: page,
        limit: limit,
      };
      dispatch(getHistoryStartOne(postObj));
      if (refreshPersonalList) refreshPersonalList();
      dispatch(
        getUserLists({
          limit: 99999,
          page: 1,
        })
      );
    });
    setCancelAlert(false);
    setSelectedOrder(null);
    setCancelReason('');
    setCancelReasonError(false);
  };

  const handleUpdateInvoice = (order) => {
    setSelectedOrder(order);
    setInvoiceAlert(true);
  };

  const confirmUpdateInvoice = () => {
    const postData = {
      orderId: selectedOrder.order_id,
      taxid: selectedOrder.taxid || '',
      invoiced_at: moment().format('YYYY-MM-DD HH:mm:ss'),
    };
    dispatch(updateInvoiceStatus(postData)).then(() => {
      const postObj = {
        user_id: isOpen?.user_information?.user_id,
        page: page,
        limit: limit,
      };
      dispatch(getHistoryStartOne(postObj));
      if (refreshPersonalList) refreshPersonalList();
    });
    setInvoiceAlert(false);
    setSelectedOrder(null);
  };

  const handleStartEdit = (data) => {
    setEditingOrderId(data.order_id);
    setEditTaxId(data.taxid || "");
  };

  const handleSaveEdit = (orderId) => {
    dispatch(updateInvoiceStatus({ orderId, taxid: editTaxId })).then(() => {
      const postObj = {
        user_id: isOpen?.user_information?.user_id,
        page: page,
        limit: limit,
      };
      dispatch(getHistoryStartOne(postObj));
      if (refreshPersonalList) refreshPersonalList();
    });
    setEditingOrderId(null);
  };

  const handleFileUpload = (e, orderId) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(postManualInvoice({ orderId, file })).then(() => {
        const postObj = {
          user_id: isOpen?.user_information?.user_id,
          page: page,
          limit: limit,
        };
        dispatch(getHistoryStartOne(postObj));
      });
    }
  };

  const handleDownloadInvoice = (data) => {
    dispatch(getManualInvoice({ orderId: data?.order_id })).then((res) => {
      if (res.payload && res.payload.data) {
        const contentType = res.payload.headers["content-type"];
        const extension = contentType ? contentType.split("/")[1] : "png";
        const url = window.URL.createObjectURL(
          new Blob([res.payload.data], { type: contentType })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `發票_${data?.order_number}_${moment(data?.invoiced_at).format("YYYY-MM-DD")}.${extension}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } 
    });
  };

  const handleRemoveInvoice = (orderId) => {
    dispatch(deleteManualInvoice({ orderId })).then(() => {
      const postObj = {
        user_id: isOpen?.user_information?.user_id,
        page: page,
        limit: limit,
      };
      dispatch(getHistoryStartOne(postObj));
    });
  };

  // useEffect(() => {
  //   const history = findTopUpForUser(isOpen);
  //   const resultHistory = getTopUpValue(history, ["giftHistory"]);

  //   const topUp = findTopUpForUser(isOpen);
  //   const topUpHistory = getTopUpValue(topUp, ["topUpHistory"]);

  //   setOrderHistory(resultHistory?.concat(topUpHistory));
  // }, [isOpen, findTopUpForUser, getTopUpValue]);

  return (
    <Modal isOpen={isOpen} size='xxl'>
      <div className={styles.ModalContainer}>
        <div className={`${styles.modalHeader} ${styles.special}`}>
          <div className={styles.modalTitle}>購買紀錄</div>
          <Button
            type='tertiary'
            icon={<MdClear />}
            onClick={() => {
              setIsOpen(false);
              setPage(1);
            }}
          />
        </div>
        <div className={`${styles.modalBody} ${styles.nonOverflow}`}>
          <Table header={headerData}>
            {loading ? (
              <LoadingTable row={10} column={7} />
            ) : order_history?.rows?.length > 0 ? (
              <tbody>
                {order_history?.rows?.map((data, index) => (
                  <tr key={index}>
                    <td width={`${headerData[0].width}%`}>
                      {moment(data.created_at).format(
                        "YYYY-MM-DD"
                      )}
                    </td>
                    {/* gift-charge, charge, voucher, referral, invite_code */}
                    <td width={`${headerData[1].width}%`}>
                      {data.advanced_type === "gift-charge" && "贈送儲值金"}
                      {data.advanced_type === "charge" && "購買儲值金"}
                      {data.advanced_type === "voucher" && "優惠碼儲值金"}
                      {data.advanced_type === "referral" && "推薦碼儲值金"}
                      {data.advanced_type === "invite_code" && "優惠碼 + 推薦碼儲值金"}
                      {data.type === "gift-cancel" && "取消贈送"}
                    </td>
                    <td width={`${headerData[2].width}%`}>
                      NT$ {(data?.points)?.toLocaleString() || 0}
                    </td>
                    <td width={`${headerData[3].width}%`}>
                      {(data.order_payment_status === "paid") && (data.advanced_type === "gift-charge" || data.type === "gift-cancel") && "中控贈送"}
                      {(data.order_payment_status === "cancelled") && (data.advanced_type === "gift-charge" || data.type === "gift-cancel") && "取消贈送"}
                      {data.order_payment_status === "paid" && data.advanced_type === "charge" && "信用卡扣款"}
                      {data.order_payment_status === "paid" && (data.advanced_type === "referral" || data.advanced_type === "invite_code") && "推薦碼贈送"}
                      {data.order_payment_status === "paid" && data.advanced_type === "voucher" && "優惠碼贈送"}
                      {data.order_payment_status === "unauth" && "未授權"}
                    </td>
                    <td width={`${headerData[4].width}%`}>
                      {editingOrderId === data.order_id ? (
                        <div className={styles.editTaxIdContainer}>
                          <input
                            type="text"
                            value={editTaxId}
                            onChange={(e) => setEditTaxId(e.target.value)}
                            className={styles.editTaxIdInput}
                          />
                          <div className={styles.editActions}>
                            <FiCheck
                              className={styles.saveIcon}
                              onClick={() => handleSaveEdit(data.order_id)}
                            />
                            <MdClear
                              className={styles.cancelIcon}
                              onClick={() => setEditingOrderId(null)}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className={styles.taxIdValue}>
                          {data.taxid || '-'}
                          <MdEdit
                            className={styles.editIcon}
                            onClick={() => handleStartEdit(data)}
                          />
                        </div>
                      )}
                    </td>
                    <td width={`${headerData[5].width}%`}>
                      {(data.order_payment_status === "paid" || data.order_payment_status === "unauth") && (data.advanced_type === "gift-charge" || data.advanced_type === "referral") ? (
                        <span className={`${styles.historyStatus} ${styles.primary}`}>
                          {data.advanced_type === "referral" ? "推薦碼贈送成功" : "中控贈送成功"}
                        </span>
                      ) : data.order_payment_status === "cancelled" && (data.advanced_type === "gift-charge" || data.type === "gift-cancel") ? (
                        <span className={`${styles.historyStatus} ${styles.failed}`}>
                          取消贈送成功
                        </span>
                      ) : data.order_payment_status === "paid" && (data.advanced_type === "voucher") ? (
                        <span className={`${styles.historyStatus} ${styles.primary}`}>
                          優惠碼贈送成功
                        </span>
                      ) : (
                        <span className={`${styles.historyStatus} ${styles.success}`}>
                          付款成功
                        </span>
                      )}
                    </td>

                    <td width={`${headerData[6].width}%`}>
                      {data.advanced_type === "gift-charge" && (
                        <>
                          {data.order_payment_status === "cancelled" ? (
                            <span className={`${styles.historyStatus} ${styles.warning}`}>
                              已取消
                            </span>
                          ) : (
                            <span
                              className={`${styles.historyStatus} ${styles.failed}`}
                              style={{ cursor: 'pointer' }}
                              onClick={() => handleCancelOrder(data)}>
                              取消
                            </span>
                          )}
                        </>
                      )}
                      {(data.advanced_type === "charge" && data.order_payment_status === "paid") && (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          {data.invoiced_at ? (
                            <span className={styles.invoicedTag}>
                              已開發票
                            </span>
                          ) : (
                            <span
                              className={styles.invoiceBtn}
                              onClick={() => handleUpdateInvoice(data)}>
                              <FiCheck fontSize={18} />
                              開發票狀態
                            </span>
                          )}
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <span
                              className={`${styles.invoiceActionBtn}`}
                              style={{ cursor: resendingIds.includes(data.order_id) ? 'not-allowed' : 'pointer', opacity: resendingIds.includes(data.order_id) ? 0.5 : 1 }}
                              onClick={() => !resendingIds.includes(data.order_id) && handleResendInvoice(data)}
                            >
                              <MdMarkEmailRead fontSize={16} />
                              補送發票
                            </span>
                            <label className={`${styles.invoiceActionBtn} ${styles.upload}`}>
                              <input
                                type="file"
                                style={{ display: 'none' }}
                                onChange={(e) => handleFileUpload(e, data.order_id)}
                              />
                              <FiUpload fontSize={16} />
                              上傳發票
                            </label>
                            {data.invoice_file_exists && (
                              <>
                                <span
                                  className={`${styles.invoiceActionBtn} ${styles.download}`}
                                  onClick={() => handleDownloadInvoice(data)}
                                >
                                  <FiDownload fontSize={16} />
                                  下載發票
                                </span>
                                <span
                                  className={`${styles.invoiceActionBtn} ${styles.delete}`}
                                  onClick={() => handleRemoveInvoice(data.order_id)}
                                >
                                  <MdClear fontSize={16} />
                                  刪除發票
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody style={{ height: '450px' }}>
                <tr>
                  <td colSpan={10}>
                    <EmptyBox type={1} caption={'目前還未有任何紀錄'} />
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
        <div className={`${styles.modalFooter} ${styles.normal}`}>
          {order_history?.total > 0 && (
            <Paginate
              onPageChange={pageChangeHandler}
              pageCount={page}
              limit={limit}
              totalPages={Math.ceil(order_history?.total / limit)}
              totalData={order_history?.total}
            />
          )}
        </div>
      </div>

      <Alert
        isOpen={cancelAlert}
        mainTitle='確認取消訂單'
        subTitle='您確定要取消此訂單嗎？此操作無法復原。'
        leftButtonText='返回'
        rightButtonText='確認取消'
        isWarning={true}
        onClose={() => {
          setCancelAlert(false);
          setCancelReason('');
          setCancelReasonError(false);
        }}
        onConfirm={confirmCancelOrder}
        showInput={true}
        inputName='取消原因'
        inputValue={cancelReason}
        onInputChange={(value) => {
          setCancelReason(value);
          if (cancelReasonError && value.trim()) {
            setCancelReasonError(false);
          }
        }}
        inputError={cancelReasonError}
        inputErrorMessage='請輸入取消原因'
      />

      <Alert
        isOpen={invoiceAlert}
        mainTitle='確認開發票狀態為「已開發票」'
        subTitle='您確定要為此訂單開發票狀態為「已開發票」嗎？'
        leftButtonText='返回'
        rightButtonText='確認'
        onClose={() => {
          setInvoiceAlert(false);
          setSelectedOrder(null);
        }}
        onConfirm={confirmUpdateInvoice}
      />
    </Modal>
  );
};

export default ModalHistory;
